/* eslint-disable */
import { Grid, Paper, TextField, Typography } from '@mui/material'
import { Controller } from 'react-hook-form'
import PasswordField from '../../components/PasswordField'

export default function UserInfo({ isEditing, control, errors, isUpdate }: any) {
  return (
    <Grid item xs={12} md={5}>
      <Typography variant='h6' sx={{ paddingLeft: '30px' }}>
        User Info
      </Typography>
      <Paper
        elevation={0}
        style={{
          padding: '16px',
          height: '55vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
        }}
      >
        <Controller
          name='firstname'
          control={control}
          render={({ field: { name: fieldName, value, onChange, onBlur, ref } }) => (
            <TextField
              name={fieldName}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              ref={ref}
              label='First Name'
              fullWidth
              margin='normal'
              disabled={!isEditing}
              error={!!errors.firstname}
              helperText={errors.firstname ? errors.firstname.message : ''}
            />
          )}
        />
        <Controller
          name='lastname'
          control={control}
          render={({ field: { name: fieldName, value, onChange, onBlur, ref } }) => (
            <TextField
              name={fieldName}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              ref={ref}
              label='Last Name'
              fullWidth
              margin='normal'
              disabled={!isEditing}
              error={!!errors.lastname}
              helperText={errors.lastname ? errors.lastname.message : ''}
            />
          )}
        />
        <Controller
          name='email'
          control={control}
          render={({ field: { name: fieldName, value, onChange, onBlur, ref } }) => (
            <TextField
              name={fieldName}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              ref={ref}
              label='Email'
              fullWidth
              margin='normal'
              disabled={!isEditing}
              error={!!errors.email}
              helperText={errors.email ? errors.email.message : ''}
            />
          )}
        />

        {!isUpdate && (
          <PasswordField
            name='password'
            label='Password'
            control={control}
            errors={errors}
            disabled={!isEditing}
          />
        )}

        <Controller
          name='phonenumber'
          control={control}
          render={({ field: { name: fieldName, value, onChange, onBlur, ref } }) => (
            <TextField
              name={fieldName}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              ref={ref}
              label='Phone Number (optional)'
              fullWidth
              placeholder='e.g., 6471234567 or +16471234567'
              margin='normal'
              disabled={!isEditing}
              error={!!errors.phonenumber}
              helperText={errors.phonenumber ? errors.phonenumber.message : ''}
            />
          )}
        />
      </Paper>
    </Grid>
  )
}
